export const TREE = Symbol("@@Reatom/TREE");
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop() { }
// eslint-disable-next-line prefer-destructuring
export const assign = Object.assign;
export const equals = Object.is;
export function getTree(thing) {
    return thing && thing[TREE];
}
export function getName(treeId) {
    return typeof treeId === "symbol"
        ? treeId.description || treeId.toString().replace(/Symbol\((.*)\)/, "$1")
        : treeId;
}
export function getIsAtom(thing) {
    const vertex = getTree(thing);
    return Boolean(vertex && !vertex.isLeaf);
}
export function getIsAction(thing) {
    const vertex = getTree(thing);
    return Boolean(vertex && vertex.isLeaf);
}
let id = 0;
export function nameToIdDefault(name) {
    return typeof name === "symbol"
        ? // TODO: https://github.com/microsoft/TypeScript/issues/1863
            name
        : Array.isArray(name)
            ? safetyStr(name[0], "name")
            : `${safetyStr(name, "name")} [${++id}]`;
}
let _nameToId;
export function nameToId(name) {
    return _nameToId ? _nameToId(name) : nameToIdDefault(name);
}
export function setNameToId(gen) {
    _nameToId = safetyFunc(gen, "gen");
}
export function throwError(error) {
    // TODO: add link to docs with full description
    throw new Error(`[reatom] ${error}`);
}
export function safetyStr(str, name) {
    if (typeof str !== "string" || str.length === 0)
        throwError(`Invalid ${name}`);
    return str;
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function safetyFunc(func, name) {
    if (typeof func !== "function")
        throwError(`Invalid ${name}`);
    return func;
}
export function getOwnKeys(obj) {
    const keys = Object.keys(obj);
    keys.push(...Object.getOwnPropertySymbols(obj));
    return keys;
}
